module["exports"] = [
  "Türkiye"
];
